import { useState } from "react";
import { cn } from "@/shared/utils/cn";
import type { BuilderDropTarget } from "../types/builderDragTypes";

interface BuilderDropZoneProps {
  target: BuilderDropTarget;
  active: boolean;
  label: string;
  onDrop: (target: BuilderDropTarget) => void;
}

export function BuilderDropZone({ target, active, label, onDrop }: BuilderDropZoneProps) {
  const [over, setOver] = useState(false);
  return (
    <div
      data-drop-section={target.sectionId ?? "root"} data-drop-index={target.index}
      aria-label={label}
      onDragOver={event => {
        if (!active) return;
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={event => {
        if (!active) return;
        event.preventDefault();
        event.stopPropagation();
        setOver(false);
        onDrop(target);
      }}
      className={cn("flex items-center justify-center rounded-xl text-xs transition-colors",
        active ? "my-2 min-h-11 border border-dashed border-primary text-primary" : "h-3",
        active && over && "bg-accent ring-2 ring-ring")}
    >
      {active && "Drop here"}
    </div>
  );
}
